import { disableBodyScroll } from 'body-scroll-lock';
import { logging, LOG_EVENT, LOG_SCENE } from './api/log';
import { LOCALE_DATA } from './constant';
import { Game, Store } from './core';
import { BlackFrameCutAway } from './cutaway';
import { MainScene, ShareScene } from './scene';
import 'antd/dist/antd.min.css';
import { message } from 'antd';
import PeerStore from './class/PeerStore';
import { parse } from 'querystring';
import MultiplayRoom from './scene/MultiplayRoom';

function createShareComponents(game: Game): void {
  const textfield = document.createElement('textarea');
  textfield.id = 'sharelink';
  textfield.value = '';
  textfield.style.width = '0';
  textfield.style.position = `absolute`;
  textfield.style.opacity = '0';
  textfield.style.pointerEvents = 'none';
  document.body.appendChild(textfield);

  const button = document.createElement('button');
  button.id = 'sharebtn';
  button.innerText = LOCALE_DATA[Store.instance.state.locale].SHARE;
  button.style.display = 'none';
  button.style.fontSize = '34px';
  button.style.fontFamily = 'gaegu';
  button.style.position = 'absolute';
  button.style.bottom = '10px';
  button.style.textAlign = 'center';
  button.style.background = 'transparent';
  button.style.border = 'none';
  button.style.color = '#FFFFFF';
  button.style.filter = 'drop-shadow(2px 4px 6px black)';

  if (LOCALE_DATA[Store.instance.state.locale].SHARE === 'ko-KR') {
    button.style.width = '320px';
    button.style.left = 'calc(50% - 160px)';
  } else {
    button.style.width = '320px';
    button.style.left = 'calc(50% - 160px)';
  }
  document.body.appendChild(button);

  button.addEventListener('click', (event) => {
    textfield.select();
    game.emit('shared');
    document.execCommand('copy');
    textfield.blur();
  });
}

function initializeGoogleAdvertisement(): void {
  (window as any).adsbygoogle = (window as any).adsbygoogle || [];
  (window as any).adBreak = function (o: any) {
    (window as any).adsbygoogle.push(o);
  };
}

async function main(): Promise<void> {
  initializeGoogleAdvertisement();
  disableBodyScroll(document.body);

  const mainDOM = document.getElementById('main');
  const game: Game = Game.instance;
  await game.preloadForLoading();

  game.append(mainDOM as HTMLElement);
  game.start();

  createShareComponents(game);

  const defaultCutway = new BlackFrameCutAway();
  defaultCutway.setSize(game.width, game.height);
  game.cutaway = defaultCutway;

  game.changeScene(MainScene);

  await game.preload();

  const cutaway = new BlackFrameCutAway();
  cutaway.setSize(game.width, game.height);
  game.cutaway = cutaway;

  const [hash] = window.location.hash.split('?');
  switch (hash) {
    case '#/share':
      await game.changeScene(ShareScene);
      logging(LOG_EVENT.VISIT, LOG_SCENE.SHARE_SCENE, Store.instance.data.playername, window.navigator.userAgent);
      break;
    case '#/multiplay':
      try {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_hash, querystring] = window.location.hash.split('?');
        const { code: roomCode } = parse(querystring);
        if (roomCode?.length !== 5) throw new Error('invaild code');
        // TODO: Signal Server
        const code = await PeerStore.instance.peer.connectSignalSocket(
          'https://ninimo.thepinkfong.com',
          'DEFAULT',
          Store.instance.data.code
        );
        Store.instance.data.code = code;
        Store.instance.save();
        await PeerStore.instance.peer.connectPeer(roomCode as string);
        await game.changeScene(MultiplayRoom);
        message.success(Store.instance.state.locale === 'en-US' ? 'Connection Success' : '친구를 찾았다 니니!');
        logging(LOG_EVENT.JOIN_SUCCESS, LOG_SCENE.MAIN_SCENE, Store.instance.data.playername, window.navigator.userAgent);
      } catch (e) {
        message.error(Store.instance.state.locale === 'en-US' ? 'Connection Fail' : '친구를 찾지 못했다 니니..');
        await game.changeScene(MainScene);
        logging(LOG_EVENT.JOIN_FAIL, LOG_SCENE.MAIN_SCENE, Store.instance.data.playername, window.navigator.userAgent);
        logging(LOG_EVENT.VISIT, LOG_SCENE.MAIN_SCENE, Store.instance.data.playername, window.navigator.userAgent);
      }
      break;
    default:
      await game.changeScene(MainScene);
      logging(LOG_EVENT.VISIT, LOG_SCENE.MAIN_SCENE, Store.instance.data.playername, window.navigator.userAgent);
  }

  if (process.env.NODE_ENV === 'development') {
    (window as any).game = game;
  }
}

requestAnimationFrame(main);
